// Default version: 0.0.0-DEFAULT
export const appVersion = '0.0.3-SNAPSHOT';
